export const formatDate = (date?: Date | null): string => {
  if (!date) return '';
  return date.toLocaleString('en-GB', {
    weekday: 'long',   // "Monday"
    month: 'long',     // "January"
    day: 'numeric',    // "31"
    year: 'numeric',   // "2026"
    hour: '2-digit',   // "18"
    minute: '2-digit', // "00"
    hour12: false,     // 24-hour
  });
};
